<template>
    <div>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            :viewBox="viewBox"
            width="100%"
            height="100%"
        >
            <path class="svg-base" :d="path"/>
        </svg>
    </div>
</template>

<script>
import icons from './icons'
export default {
    name: 'Tcon',
    props: {
        icon: {
            type: String,
            default: "f-exclamation-triangle"
        },
        size: {
            type: String,
            default: 'md',
        },
    },
    watch: {
        icon: function() {
            this.getPath();
        }
    },
    data(){
        return {
            viewBox: '0 0 16 16',
            path: "",
        };
    },
    mounted(){
        this.calcViewBox();
        this.getPath();
    },
    methods: {
        calcViewBox() {
            switch (this.size) {
                case 'sm':
                    this.viewBox = '0 0 16 16';
                    break;
                case 'lg':
                    this.viewBox = '0 0 64 64';
                    break;
                default:
                    this.viewBox = '0 0 32 32';
            }
        },
        getPath() {
            const icon_array = this.icon.split('-');
            const icon_type = icon_array[0] === 'p' ? 'pictogram' : 'functional';
            const icon = icon_array.slice(1).join('-');
            this.path = icons[icon_type][icon][this.size];
        }
    }
}
</script>

<style scoped>
div {
    display: inline-block;
}
</style>